import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link, useNavigate } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useRef } from 'react';
import useLocalStorage from "use-local-storage";
// import useAuth from "../../hooks/useAuth";
import { LoadScript } from '@react-google-maps/api';
import { Autocomplete } from '@react-google-maps/api';

import Navbar from '../layout/Navbar';
// import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { handleLogin, sendEmail } from '../api';
import { siteName, AppContext } from '../main';
import { loadStripe } from "@stripe/stripe-js";


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_MODUPE);

const NavLink = (props) => {
  return <Link {...props} />;
};

const image1 = "./img/background/2.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
  .h-100{
    height: 100vh !important;
  }
`;

const Services = (props) => {
  const { appState, setAppState } = useContext(AppContext);
  const {
    services,
    pricelists: temp,
    pricings
  } = appState;
  const {
    // services = [
    //   { name: "weddingPhotography", value: "weddingPhotography" },
    //   { name: "eventPhotography", value: "eventPhotography" },
    //   { name: "portraitPhotography", value: "portraitPhotography" },
    //   { name: "productPhotography", value: "productPhotography" },
    //   { name: "realEstatePhotography", value: "realEstatePhotography" },
    //   { name: "fashionPhotography", value: "fashionPhotography" },
    //   { name: "travelPhotography", value: "travelPhotography" },
    //   { name: "sportsPhotography", value: "sportsPhotography" },
    //   { name: "newbornPhotography", value: "newbornPhotography" },
    //   { name: "foodPhotography", value: "foodPhotography" }
    // ]

  } = props
  const navigate = useNavigate();
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const [loading, setLoading] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [tiers, setTiers] = useState([]);
  const { myInfo } = myStore;

  const addressRef = useRef(null);

  const handlePlaceChanged = () => {
    if (addressRef.current) {
      const place = addressRef.current.getPlace();
      const fullAddress = place?.formatted_address || '';
      setFormData((prev) => ({ ...prev, address: fullAddress }));
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600)
    }
  }, []);

  useEffect(() => {
    if (temp?.plans?.[0]) {
      setServiceTypes(temp?.plans?.map(res => {
        return {
          ...res,
          name: res?.title,
          value: res?.title
        }
      }))
      // console.log('temp', temp)
      // setTiers(temp?.plans?.map(res => {
      //   return {
      //     name: `Slot ${res?.slots}`,
      //     value: res?.title,
      //   }
      // }))


    }
  }, [temp])

  // const { signIn } = useAuth();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    serviceType: '',
    tier: '',
    preferredDate: '',
    startTime: '',
    flexibility: false,
    address: '',
    accessNotes: '',
    fullName: '',
    email: '',
    phoneNumber: '',
    documents: [],
    paymentStatus: 'unpaid',
    transactionID: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (type === 'file') {
      setFormData({ ...formData, documents: Array.from(files) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const nextStep = () => setStep((prev) => Math.min(prev + 1, 8));
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));
  const handlePayment = async (priceId) => {
    try {
      const stripe = await stripePromise;

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        lineItems: [
          {
            price: priceId, // The ID of the price you created in Stripe dashboard
            quantity: 1,
          },
        ],
        mode: 'subscription',
        successUrl: window.location.origin + '/success',
        cancelUrl: window.location.origin + '/cancel',
      });

      if (error) {
        console.error(error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = () => {
    if (formData?.serviceType) {
      const priceId = serviceTypes?.filter(ref => {
        return ref?.title.toLowerCase() == formData?.serviceType.toLowerCase()
      })?.[0]?.priceId
      if (priceId) {
        handlePayment(priceId)
      }
    }
    // setStep(8); // Success page
  };

  const emailObject = {
    to: formData?.email,
    subject: "Message from GuestNet Planner ✔",
    text: "", 
    html: `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>${"Action Event on your event"}</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">
<table align="center" border="0" cellpadding="0" cellspacing="0" width="600" style="border-collapse: collapse;">
<tr>
    <td align="center" bgcolor="#ffffff" style="padding: 40px 0 30px 0;">
    </td>
</tr>
<tr>
    <td bgcolor="#ffffff" style="padding: 40px 30px 40px 30px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;">
            <tr>
                <td style="color: #153643; font-size: 24px; font-weight: bold; text-align: center;">
                    Balance your Work/Live with GuestNet Planner!
                </td>
            </tr>
            <tr>
                <td style="padding: 20px 0 30px 0; color: #153643; font-size: 16px; line-height: 20px; text-align: center;">
                has just completed an action on your page for event.
                </td>
            </tr>
            <tr>
                <td align="center" style="">
                    
                </td>
            </tr>
        </table>
    </td>
</tr>
<tr>

</tr>
</table>
</body>
</html>
`,
  };

  const submitRequest = async () => {
    sendEmail(emailObject).then((res) => console.log(res, 'res email'))
  }
  


  const renderStep = () => {
    const getLabel = (name) =>
      name
        .replace(/([A-Z])/g, ' $1') // Insert space before capital letters
        .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter

    switch (step) {
      case 1:
        return (
          <>
            <h5>Select a Service</h5>
            <div className="field-set" >
              <label>{getLabel("serviceType")}</label>
              <select
                className="form-control"
                name="serviceType"
                value={formData.serviceType}
                onChange={handleChange}>
                <option value="">-- Choose --</option>
                {serviceTypes?.map(res => {
                  return <option value={res.value}>{res?.name}</option>
                })}
                {/* <option value="plumbing">Plumbing</option> */}
              </select>
            </div >

          </>
        );
      case 2:
        return (
          <>
            <h5>Choose Date & Time</h5>
            <div className="field-set">
              <label>{getLabel("preferredDate")}</label>
              <input
                className="form-control"
                type="date"
                name="preferredDate"
                value={formData.preferredDate}
                onChange={handleChange}
              />
            </div>
            <div className="field-set">
              <label>{getLabel("startTime")}</label>
              <input
                className="form-control"
                type="time"
                name="startTime"
                value={formData.startTime}
                onChange={handleChange}
              />
            </div>
            <label>
              <div className="field-set">
                <label>{getLabel("flexibility")} Timing</label>
                <input
                  // className="form-control"
                  type="checkbox"
                  name="flexibility"
                  checked={formData.flexibility}
                  onChange={handleChange}
                />
              </div>
            </label>
          </>
        );
      case 3:
        return (
          <>
            <h5>Service Location</h5>
            <div className="field-set">
              <label>{getLabel("address")}</label>
              <Autocomplete onLoad={(ref) => (addressRef.current = ref)} onPlaceChanged={handlePlaceChanged}>
                <input
                  className="form-control"
                  type="text"
                  name="address"
                  placeholder="Full Address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </Autocomplete>
            </div>
            {/* <h5>Service Location</h5>
            <div className="field-set">
              <label>{getLabel("address")}</label>
              <input
                className="form-control"
                type="text"
                name="address"
                placeholder="Full Address"
                value={formData.address}
                onChange={handleChange}
              />
            </div> */}
            <div className="field-set">
              <label>{getLabel("accessNotes")}</label>
              <input
                className="form-control"
                type="text"
                name="accessNotes"
                placeholder="Access Instructions"
                value={formData.accessNotes}
                onChange={handleChange}
              />
            </div>
          </>
        );
      case 4:
        return (
          <>
            <h5>Contact Information</h5>
            <div className="field-set">
              <label>{getLabel("fullName")}</label>
              <input
                className="form-control"
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
              />
            </div>
            <div className="field-set">
              <label>{getLabel("email")}</label>
              <input
                className="form-control"
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="field-set">
              <label>{getLabel("phoneNumber")}</label>
              <input
                className="form-control"
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>
          </>
        );
      case 5:
        return (
          <>
            <h5>Upload Additional Documents</h5>
            <input
              className="form-control"
              type="file"
              name="documents"
              multiple
              onChange={handleChange}
            />
            {formData.documents.length > 0 && (
              <ul>
                {formData.documents.map((file, idx) => (
                  <li key={idx}>{file.name}</li>
                ))}
              </ul>
            )}
          </>
        );
      case 6:
        return (
          <>
            <h5>Review & Confirm</h5>
            <pre>{JSON.stringify(formData, null, 2)}</pre>
          </>
        );
      case 7:
        return (
          <>
            <h5>Payment (Optional)</h5>
            <p>We'll collect payment later or on-site. You’re all set!</p>
            <button
              onClick={() => {
                setFormData({
                  ...formData,
                  paymentStatus: 'paid',
                  transactionID: 'txn_123456',
                });
                handleSubmit();
              }}>
              Mark as Paid & Confirm
            </button>
          </>
        );
      case 8:
        return (
          <>
            <h5>✅ Booking Confirmed</h5>
            <p>Thanks {formData.fullName}! We’ve received your request.</p>
            <p>
              We’ll reach out to you shortly via {formData.email} or {formData.phoneNumber}.
            </p>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {/* <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>{siteName}</title>
      </Helmet>

      <GlobalStyles />

      <div id='mainpreloader'>
        <Preloader />
      </div> */}

      <div className="home dark-scheme">
        {/* <header id="header-wrap">
          <Navbar />
        </header> */}

        {/* section */}
        <LoadScript googleMapsApiKey={process.env.YOUR_GOOGLE_MAPS_API_KEY || 'AIzaSyDGql5DgxxAWyT3HXGhhv2q-zk4IhR5XEE'} libraries={['places']}>

          <Parallax className="" bgImage={image1} strength={5}>
            <div className="de-gradient-edge-top"></div>
            <div className="de-gradient-edge-bottom"></div>
            <section className="no-bg h-100">
              <div style={{
                maxWidth: 500, margin: '0 auto', padding: 20,
                width: 450
              }}>
                <div>{renderStep()}</div>
                {step < 8 && (
                  <div style={{
                    display: 'flex',
                    marginTop: 20, flexDirection: 'row'
                  }}>
                    {step > 1 && <button
                      className="btn-main btn-fullwidth rounded-3"
                      style={{
                        width: '35%'
                      }}
                      onClick={prevStep}>Back</button>}
                    {step < 6 && <button
                      className="btn-main btn-fullwidth rounded-3"

                      onClick={nextStep} style={{ marginLeft: 10, width: '33%' }}>Next</button>}
                      {step === 6 && <button
                      className="btn-main btn-fullwidth rounded-3"
                      onClick={submitRequest} style={{ marginLeft: 10, width: '33%' }}>Submit Request</button>}
                    {step === 6 && <button
                      className="btn-main btn-fullwidth rounded-3"
                      onClick={handleSubmit} style={{ marginLeft: 10, width: '33%' }}>Go to Checkout</button>}
                  </div>
                )}
              </div>
            </section>
          </Parallax>
        </LoadScript>


        {/* <Footer /> */}
      </div>
      <ScrollToTopBtn />
    </>
  );
}


export default Services;